import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { DataSource } from '@angular/cdk/table';
import { BehaviorSubject, Observable, of, fromEvent } from 'rxjs';
import { CollectionViewer } from '@angular/cdk/collections';
import { catchError, finalize, tap, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { LoginHistoryService} from 'src/app/services/login-history.service';
import { CommonfilterService } from 'src/app/services/commonfilter.service';
import { projectConstants } from 'src/app/shared/constants/project-constants';
import { ActivatedRoute, Router } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';

@Component({
  selector: 'app-login-history',
  templateUrl: './login-history.component.html',
  styleUrls: ['./login-history.component.css']
})
export class LoginHistoryComponent implements OnInit, AfterViewInit {

  collapsed;
  auditCount: number;

  tableFilters = '';

   dataSource = new LoginHistoryDataSource(this.loginHistoryService,this.activatedRoute,this.router);

  displayedColumns = [ 'accountId','userId','userType', 'userName', 'phoneNumber', 'UserAgent',  'LoggedIn', 'LoggedOut', 'ipAddress'];
  loginHistoryCount: any;
  sectors: any;
  configData: any;
  userAgents: any = [];
  userAgentModal = 0 ; serviceSectorModal = 0;userTypeModal = 0;
  screenHeight;
  screenWidth;
  small_device_display = false;
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;

  @ViewChild('go', {static: false}) button: ElementRef;
  userTypes: any = [];
  ActivatedRoute: ActivatedRoute;

  constructor(private loginHistoryService: LoginHistoryService,
     private commonService: CommonfilterService,private activatedRoute: ActivatedRoute,
     private router: Router
    ) { 
    this.commonService.getServiceSectors()
      .subscribe(res => {
        this.sectors = res;
        console.log(JSON.stringify(this.sectors));
      });
      this.commonService.getConfigData()
      .subscribe(res => {
       this.configData = res;
       this.userAgents = this.configData.userAgentType;
       this.userTypes = this.configData.userType;

      });
      this.onResize();
  }

  ngOnInit() {
    this.getTotalCount(this.tableFilters);
    this.dataSource.loadLoginHistory( '', 'false', 0, 100);

  }
  ngAfterViewInit() {

    this.paginator.page
    .pipe(
        tap(() => this.loadloginHistoryPage())
    )
    .subscribe();


    fromEvent(this.button.nativeElement, 'click')
    .pipe(
        debounceTime(150),
        distinctUntilChanged(),
        tap(() => {
            this.tableFilters = this.commonService.createfilterParams('loginHistory');
            this.getTotalCount(this.tableFilters);
            this.paginator.pageIndex = 0;
            this.loadloginHistoryPage();

        })
    )
    .subscribe();

}
loadloginHistoryPage() {
  const counte = (this.paginator.pageSize * (this.paginator.pageIndex + 1)) - 100;

  this.dataSource.loadLoginHistory(

    this.tableFilters,
    'false',
    counte,
    this.paginator.pageSize);
}
onResize() {
  this.screenHeight = window.innerHeight;
  this.screenWidth = window.innerWidth;
  console.log(this.screenWidth);
  if (this.screenWidth <= projectConstants.SMALL_DEVICE_BOUNDARY) {
    console.log(projectConstants.SMALL_DEVICE_BOUNDARY);
    console.log(this.screenWidth);
    this.small_device_display = true;
  } else {
    this.small_device_display = false;
  }
}
  getTotalCount(filters) {
    this.loginHistoryService.getTotalFilterCount(filters)
    .subscribe( res => this.loginHistoryCount = res);
  }
  getServiceSector(sectorId) {
    let serviceSectorName =  'N.A';
    for (let j = 0; j < this.sectors.length; j++) {
      if (this.sectors[j].id === sectorId) {
        serviceSectorName = this.sectors[j].displayName;
      }
    }
    return serviceSectorName;

  }
  getDetails(row){
    // console.log(row.userType)
    if(row.userType === 'PROVIDER'){
      this.router.navigate(['../accounts/view', row.accountId ,'details'], {relativeTo: this.activatedRoute });
    }else{
      this.router.navigate(['../customers/view', row.user.id], {relativeTo: this.activatedRoute });
    }
  }
}
export class LoginHistoryDataSource implements DataSource<any> {

  private loginSubject = new BehaviorSubject<any>([]);

  private loadingSubject = new BehaviorSubject<boolean>(false);

  public loading$ = this.loadingSubject.asObservable();
  type: any;
  history: any;

  constructor(private loginHistoryService: LoginHistoryService, private activatedRoute: ActivatedRoute,
    private router: Router) {

  }
  connect(collectionViewer: CollectionViewer): Observable<any> {
     return this.loginSubject.asObservable();

  }
  disconnect(collectionViewer: CollectionViewer): void {
    this.loginSubject.complete();
    this.loadingSubject.complete();
  }

  loadLoginHistory( filter,
  sortDirection, tcount, pageSize) {

  this.loadingSubject.next(true);

  this.loginHistoryService.getLoginHistory( filter, sortDirection,
    tcount, pageSize).pipe(
     catchError(() => of([])),
      finalize(() => this.loadingSubject.next(false))
    )
    .subscribe(
      history => {
       history.forEach(history_details => {
         this.history = history_details;
          this.type = this.history.userType;
          // console.log( this.type);
         });
        this.loginSubject.next(history);
      }
    );
  }
 
 
}

